module.exports = __webpack_public_path__ + "static/media/events_doodle.3e11a189.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/events_doodle.svg
// module id = 1843
// module chunks = 47